import "./CSS/terms.css"

function Terminology() {

    return (
        <div id="termBorder">
            <div id="termContainer">
                <h2>Sumo words to know:</h2>
                <p id="formore">these are only terms relevant to this Fantasy Sumo game - for more infomation about Sumo, I'd start with the <a href="https://en.wikipedia.org/wiki/Sumo">Sumo Wikipedia page</a></p>
                <div class="oneTerm">
                    <h4 class="termTitle">Ozumo</h4>
                    <p>-</p>
                    <p class="termDef">Professional sumo wrestling organized by the Japanese Sumo Association. "Sumo" can be a general term for wrestling in Japanese.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Rikishi</h4>
                    <p>-</p>
                    <p class="termDef">a professional sumo wrestler</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Shikona</h4>
                    <p>-</p>
                    <p class="termDef">a wrestler's "wrestling name," which may or may not be related to their real names. Often given to rikishi by their stablemasters. </p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Heya</h4>
                    <p>-</p>
                    <p class="termDef">A training stable run by former rikishi where active wrestlers live, eat, sleep, and train together.</p>
                </div>
                <hr></hr>
                <div class="oneTerm">
                    <h4 class="termTitle">Banzuke</h4>
                    <p>-</p>
                    <p class="termDef">A list of all wrestlers and their rankings for a particular tournament.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Makuuchi</h4>
                    <p>-</p>
                    <p class="termDef">The highest division of six divisions in Ozumo, with a maximum of 42 wrestlers, further divided into five ranks.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Juryo</h4>
                    <p>-</p>
                    <p class="termDef">The second-highest division in Ozumo, limited to 28 wrestlers.</p>
                </div>
                <hr></hr>
                <div class="oneTerm">
                    <h4 class="termTitle">Sanyaku</h4>
                    <p>-</p>
                    <p class="termDef">The "named ranks" at the top of the Makuuchi division - literally "the three ranks," even though there are four.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Yokozuna</h4>
                    <p>-</p>
                    <p class="termDef">The highest rank in all of sumo, the "grand champion" and public face of sumo. Can only attain this rank by achieving outstanding results at the Ozeki rank. Cannot be demoted.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Ozeki</h4>
                    <p>-</p>
                    <p class="termDef">The second highest rank in sumo, a "champion" rank. Rank attained through consistent notable results around the top of the banzuke. Demoted after consecutive tournaments with more losses than wins.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Sekiwake</h4>
                    <p>-</p>
                    <p class="termDef">The third highest rank in sumo, usually earned through good results around the top of the banzuke, or an outstanding previous tournament. Almost always demoted after a losing record.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Komusubi</h4>
                    <p>-</p>
                    <p class="termDef">The fourth highest rank in sumo, the lowest rank of the Sanyaku ranks. These wrestlers usually face the highest ranked wrestlers in the first week, for better or for worse...</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Maegashira</h4>
                    <p>-</p>
                    <p class="termDef">The lowest rank in the Makuuchi division - most top division wrestlers fall into this category.</p>
                </div>
                <hr></hr>
                <div class="oneTerm">
                    <h4 class="termTitle">Yusho</h4>
                    <p>-</p>
                    <p class="termDef">The tournament championship, won by the rikishi with the most match wins over the 15 tournament days. Yusho winners receive a large trophy, a cash award, and various other prizes and trophies, as well as a lifetime salary bonus.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Kinboshi</h4>
                    <p>-</p>
                    <p class="termDef">An upset of a yokozuna by a maegashira, earning a smaller lifetime salary bonus.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">San-sho</h4>
                    <p>-</p>
                    <p class="termDef">three special prizes awarded to Makuuchi rikishi for exceptional performance during a tournament: Gino-sho, Shukun-sho, and Kanto-sho. Prizes are decided by a panel, and there's no requirement that prizes must be awarded.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Gino-sho</h4>
                    <p>-</p>
                    <p class="termDef">Technique prize, usually awarded to a rikishi who displays the most skillful techniques.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Shukun-sho</h4>
                    <p>-</p>
                    <p class="termDef">Outstanding Performance prize, usually given to a rikishi who defeats the yokozuna or tournament winner.</p>
                </div>
                <div class="oneTerm">
                    <h4 class="termTitle">Kanto-sho</h4>
                    <p>-</p>
                    <p class="termDef">Fighting Spirit prize, usually awarded to a rikishi who has most clearly fought tenaciously and to the best of his abilities.</p>
                </div>
            </div>
        </div>
    )
}

export default Terminology